import * as angular from 'angular';
import { BalancingGroupUploadWizardContext, mgoAngularWizard } from '../custom';
import { BalancingGroupAssignmentResource } from 'app/_resources/balancing-group.resource';
import {
    BalancingAndPortfolioUploadWizardService,
    ShipperAssignmentPreSelection
} from 'app/_services/balancing-and-portfolio-upload-wizard.service';
import { FileService } from 'app/_services/file.service';

class BalancingGroupUploadWizardSummaryComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<BalancingGroupUploadWizardContext>;
    private balancingGroupsSummary: BalancingGroupAssignmentDto[];

    constructor(
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService,
        private balancingGroupAssignmentResource: BalancingGroupAssignmentResource,
        private fileService: FileService
    ) {}

    $onInit(): void {
        this.wizardCtrl.context.currentBalancingGroup.assignedAccessPoints =
            this.balancingAndPortfolioUploadWizardService.mapAccessPointsToModel(
                <NetworkPointDto[]>(
                    this.wizardCtrl.context.currentBalancingGroup
                        .assignedAccessPoints
                )
            );
        this.updateSummary();
    }

    public submit(): boolean {
        this.addCurrentToBalancingGroupsToSubmit();

        this.balancingGroupAssignmentResource.save(
            { assignmentDtos: this.wizardCtrl.context.balancingGroupsToSubmit },
            (res: FallbackUploadResponseDto) => {
                this.wizardCtrl.context.successMessage =
                    'The balancing group upload succeeded.';
                this.wizardCtrl.context.balancingGroupsToSubmit = [];
                this.wizardCtrl.context.errorMessage = null;
                this.wizardCtrl.finish();
            },
            (err) => {
                this.wizardCtrl.context.successMessage = null;
                this.wizardCtrl.context.errorMessage =
                    'The balancing group upload has failed.';
                this.wizardCtrl.context.balancingGroupsToSubmit = [];
            }
        );

        return true;
    }

    public removeBalancingGroup(balancingGroup: BalancingGroupAssignmentDto) {
        if (
            angular.equals(
                balancingGroup,
                this.wizardCtrl.context.currentBalancingGroup
            )
        ) {
            this.resetCurrentBalancingGroupContext();
            this.updateSummary();
        } else {
            this.wizardCtrl.context.balancingGroupsToSubmit.splice(
                this.wizardCtrl.context.balancingGroupsToSubmit.indexOf(
                    balancingGroup
                ),
                1
            );
            this.updateSummary();
        }

        if (!this.balancingGroupsSummary.length) {
            this.wizardCtrl.reset();
            this.wizardCtrl.goTo(0);
        }
    }

    public editBalancingGroup(balancingGroup: BalancingGroupAssignmentDto) {
        if (
            angular.equals(
                balancingGroup,
                this.wizardCtrl.context.currentBalancingGroup
            )
        ) {
            this.wizardCtrl.goTo(0);
            return;
        }

        this.addCurrentToBalancingGroupsToSubmit();

        const balancingGroupToEdit =
            this.wizardCtrl.context.balancingGroupsToSubmit.splice(
                this.wizardCtrl.context.balancingGroupsToSubmit.indexOf(
                    balancingGroup
                ),
                1
            );
        this.resetCurrentBalancingGroupContext();
        this.wizardCtrl.context.currentBalancingGroup = balancingGroupToEdit[0];
        this.wizardCtrl.goTo(0);
    }

    public addNewBalancingGroup(): void {
        this.addCurrentToBalancingGroupsToSubmit();
        this.resetCurrentBalancingGroupContext();
        this.wizardCtrl.goTo(0);
    }

    private updateSummary() {
        this.balancingGroupsSummary = [
            this.wizardCtrl.context.currentBalancingGroup,
            ...this.wizardCtrl.context.balancingGroupsToSubmit
        ].filter((value) => !!value);
    }

    private resetCurrentBalancingGroupContext() {
        this.wizardCtrl.context.currentBalancingGroup = null;
        this.wizardCtrl.context.selectedShippers = [];
        this.wizardCtrl.context.unselectedShippers = angular.copy(
            this.wizardCtrl.context.shippersWithAssignmentToTso
        );
        this.wizardCtrl.context.selectedCapacityCategories = [];
        this.wizardCtrl.context.unselectedCapacityCategories = angular.copy(
            this.wizardCtrl.context.allCapacityCategories
        );
    }

    private addCurrentToBalancingGroupsToSubmit() {
        if (!this.wizardCtrl.context.balancingGroupsToSubmit) {
            this.wizardCtrl.context.balancingGroupsToSubmit = [];
        }

        this.wizardCtrl.context.balancingGroupsToSubmit.push(
            this.wizardCtrl.context.currentBalancingGroup
        );
    }

    public getShipperNameByShipperIdentifier(
        shipperIdentifier: CompanyIdDto
    ): string {
        const tsoShipperAssignmentsDto =
            this.wizardCtrl.context.shippersWithAssignmentToTso.find(
                (shipperWithAssignmentToTso: TsoShipperAssignmentsDto) =>
                    shipperWithAssignmentToTso.eic === shipperIdentifier.id
            );
        return tsoShipperAssignmentsDto.shipperName;
    }

    public restartWizard() {
        this.wizardCtrl.reset();
        this.resetCurrentBalancingGroupContext();
        this.wizardCtrl.context.balancingGroupsToSubmit = [];
        this.wizardCtrl.context.errorMessage = null;
        this.wizardCtrl.context.successMessage = null;
    }

    public downloadXml() {
        this.balancingGroupAssignmentResource.generateXml(
            { assignmentDtos: this.balancingGroupsSummary },
            (res: FallbackUploadResponseDto) => {
                this.fileService.triggerFileDownload(
                    res.responseXml,
                    'upload',
                    'text/xml'
                );
            },
            (err) => {
                this.wizardCtrl.context.errorMessage =
                    'The XML download has failed.';
            }
        );
    }
}

angular.module('app').component('pkpBalancingGroupUploadWizardSummary', {
    controller: BalancingGroupUploadWizardSummaryComponentCtrl,
    template:
        require('app/balancing-group-upload-wizard/balancing-group-upload-wizard-summary.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
